import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { AppLayoutHeader } from './header/header';
import { LayoutService } from '../../core/services/layout.service';
import { ApiService } from '../../core/services/api.service';
import { DataService } from '../../core/services/data.service';
import { API_ROUTES } from '../../core/constants/api-routes';

interface ProfilePhotoData {
  profilePhotoUrl?: string;
}

@Component({
  selector: 'app-app-layout',
  templateUrl: './app-layout.html',
  styleUrl: './app-layout.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, RouterLink, RouterLinkActive, AppLayoutHeader],
})
export class AppLayout implements OnInit {
  readonly layoutService = inject(LayoutService);
  private readonly api = inject(ApiService);
  private readonly dataService = inject(DataService);

  ngOnInit(): void {
    this.syncProfilePhoto();
  }

  /**
   * Fetches the latest profile photo URL from the settings API and updates
   * the cached UserProfile so the header always shows the correct image.
   * Uses showLoader: false + showToaster: false to run silently.
   */
  private async syncProfilePhoto(): Promise<void> {
    const current = this.dataService.getProfile();
    if (!current) return;
    try {
      const res = await this.api.request<ProfilePhotoData>(
        'GET',
        API_ROUTES.SETTINGS_GET_PROFILE,
        undefined,
        { showLoader: false, showToaster: false },
      );
      const url = res.data?.profilePhotoUrl ?? '';
      if (url !== current.profileImagePath) {
        this.dataService.setProfile({ ...current, profileImagePath: url });
      }
    } catch {
      // non-fatal — header falls back to initials
    }
  }

  onSidebarToggle(): void {
    if (typeof window !== 'undefined' && window.innerWidth >= 1200) {
      this.layoutService.toggleCollapse();
    } else {
      this.layoutService.close();
    }
  }
}
